<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        <cm-tag-search-filter
            placeholder="Name, description, ..."
            [selectableTagTypes]="[Enums.TagType.ProductRange]"
            [publicLibraryCriterion]="'public'"
        ></cm-tag-search-filter>
        <cm-checkboxes-filter label="State" name="templateState" [options]="Labels.TemplateState"></cm-checkboxes-filter>
        @if ($typeLabels().size > 1) {
            <cm-checkboxes-filter
                [label]="$entityName()[0].toUpperCase() + $entityName().slice(1) + ' Type'"
                name="templateType"
                [options]="$typeLabels()"
            ></cm-checkboxes-filter>
        }
        @if ($can().read.filters("additional")) {
            <cm-checkboxes-filter label="Visibility" name="public" [options]="Labels.Public"></cm-checkboxes-filter>
            <cm-checkboxes-filter label="Payment State" name="paymentState" [options]="Labels.PaymentState"></cm-checkboxes-filter>
        }
    </cm-item-filters>
    <cm-templates-grid [viewMode]="$viewMode()"></cm-templates-grid>
</cm-sidebar-layout>
<router-outlet></router-outlet>
